export default class ProductInfo {
  constructor(http) {
    this.http = http;
  }

  // Définition du path
  pathProduct(shopId, productId) {
    return `/api/magasins/${shopId}/produits/${productId}`
  }

  async productInfo(params) {
    const response = await this.http.get(this.pathProduct(params.shopId, params.productId));
    return response.data;
  }

  async productInfoOb(magasinId, ob) {
    const url = `/api/magasins/${magasinId}/recherche-ean`;
    const config = {
      ...this.http.getConfig(),
      params: { ean: ob }
    };
    const response = await this.http.get(url, config);
    return response.data;
  }

  async productInfoConsoOb(ob) {
    const response = await this.http.get(`/api/product-infos/${ob}`);
    return response.data;
  }

  async productInfoConsoSearch(query) {
    const url = `/api/product-infos/recherche`;
    const config = {
      ...this.http.getConfig(),
      params: { query }
    };
    const response = await this.http.get(url, config);
    return response.data;
  }
}